<template>
  <div>
    <p class="mb-0 f-2 fw-600">
      {{ $t('sheet.sheetOne.reflection.calculation.title') }}
    </p>
    <v-layout mt-2>
      <v-flex
        xs3
        mr-2
      >
        <p class="mb-0 f-1 fw-600">
          {{ familyReceipt | zloty }}
        </p>
      </v-flex>
      <v-flex shrink>
        <p class="mb-0 f-1 fw-600">
          {{ $t('sheet.sheetOne.reflection.calculation.family_income') }}
        </p>
      </v-flex>
    </v-layout>
    <v-layout mt-2>
      <v-flex
        xs3
        mr-2
      >
        <p class="mb-0 f-1 fw-600">
          {{ familyReceiptPerMember | zloty }}
        </p>
      </v-flex>
      <v-flex shrink>
        <p class="mb-0 f-1 fw-600">
          {{ $t('sheet.sheetOne.reflection.calculation.income_per_member') }}
        </p>
      </v-flex>
    </v-layout>
    <p class="mb-0 mt-3 f-2 fw-600">
      {{ $t('sheet.sheetOne.reflection.calculation.summary_receipts') }}
    </p>
    <v-layout mt-2>
      <v-flex
        xs3
        mr-2
      >
        <p class="mb-0 f-1">
          {{ $t('sheet.sheetOne.reflection.calculation.work') }}
        </p>
      </v-flex>
      <v-flex shrink>
        <p class="mb-0 f-1">
          {{ totalReceiptsAmount | currency }}
        </p>
      </v-flex>
    </v-layout>
    <v-layout mt-2>
      <v-flex
        xs3
        mr-2
      >
        <p class="mb-0 f-1">
          {{ $t('sheet.sheetOne.reflection.calculation.another_sources') }}
        </p>
      </v-flex>
      <v-flex shrink>
        <p class="mb-0 f-1">
          {{ totalAnotherReceiptsAmount | currency }}
        </p>
      </v-flex>
    </v-layout>
    <v-layout mt-2>
      <v-flex
        offset-xs3
        pl-2
      >
        <p class="mb-0 f-2 fw-600">
          {{ $t('sheet.sheetOne.reflection.calculation.amount') }}: {{ receiptsSummary | zloty }}
        </p>
      </v-flex>
    </v-layout>
    <p class="mb-0 mt-3 f-2 fw-600">
      {{ $t('sheet.sheetOne.reflection.calculation.summary_costs') }}
    </p>
    <v-layout mt-2>
      <v-flex
        xs3
        mr-2
      >
        <p class="mb-0 f-1">
          {{ $t('sheet.sheetOne.reflection.calculation.house') }}
        </p>
      </v-flex>
      <v-flex shrink>
        <p class="mb-0f-1">
          {{ maintenanceExpensesAmount | currency }}
        </p>
      </v-flex>
    </v-layout>
    <v-layout
      v-if="maintenanceExpensesNurseryCost"
      mt-2
    >
      <v-flex
        xs3
        mr-2
      >
        <p class="mb-0 f-1">
          {{ $t('sheet.sheetOne.reflection.calculation.kids') }}
          <span
            v-if="!takeJob"
            class="f-05"
          >{{
            $t('sheet.sheetOne.reflection.calculation.not_deducted') | brackets
          }}</span>
        </p>
      </v-flex>
      <v-flex shrink>
        <p class="mb-0 f-1">
          {{ maintenanceExpensesNurseryCost | currency }}
        </p>
      </v-flex>
    </v-layout>
    <v-layout
      v-if="totalMedicineAmount"
      mt-2
    >
      <v-flex
        xs3
        mr-2
      >
        <p class="mb-0 f-1">
          {{ $t('sheet.sheetOne.reflection.calculation.medicine') }}
        </p>
      </v-flex>
      <v-flex shrink>
        <p class="mb-0 f-1">
          {{ totalMedicineAmount | currency }}
        </p>
      </v-flex>
    </v-layout>
    <v-layout
      v-if="creditsTotalAmount"
      mt-2
    >
      <v-flex
        xs3
        mr-2
      >
        <p class="mb-0 f-1">
          {{ $t('sheet.sheetOne.reflection.calculation.credits') }}
          <span
            v-if="
              meetingData.credits.creditReason === 72 ||
                meetingData.credits.regularCreditRepair !== 'yes'
            "
            class="f-05"
          >
            {{ $t('sheet.sheetOne.reflection.calculation.not_deducted') | brackets }}
          </span>
        </p>
      </v-flex>
      <v-flex shrink>
        <p class="mb-0 f-1">
          {{ creditsTotalAmount | currency }}
        </p>
      </v-flex>
    </v-layout>
    <v-layout mt-2>
      <v-flex
        offset-xs3
        pl-2
      >
        <p class="mb-0 f-2 fw-600">
          {{ $t('sheet.sheetOne.reflection.calculation.amount') }}: {{ maintenanceAmount | zloty }}
        </p>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import filters from '@/constants/filters';
import incomesCalculation from '@/mixins/incomesCalculation';

export default {
    name: 'FamilyIncomes',
    filters: {
        ...filters
    },
    mixins: [incomesCalculation],
    computed: {
        meetingData () {
            return this.$store.getters['sheet/getMeetingFields'];
        },
        totalReceiptsAmount () {
            return this.meetingData.cashReceipts.totalReceiptsAmount;
        },
        totalAnotherReceiptsAmount () {
            return this.meetingData.cashReceipts.totalAnotherReceiptsAmount;
        },
        maintenanceExpensesNurseryCost () {
            return this.meetingData.maintenanceExpenses.nurseryCost;
        },
        totalMedicineAmount () {
            return this.meetingData.expensesForMedicine.totalMedicineAmount;
        },
        creditsTotalAmount () {
            return this.meetingData.credits.totalAmount;
        }
    }
};
</script>

<style scoped></style>
